import Keycloak from 'keycloak-js';
import { clearToken, setupAxios } from './utils/axios';

const config = window.CONFIG;
const initOptions = config.keycloak;

const keycloak = Keycloak(initOptions);

const onAuthSuccess = () => {
  localStorage.setItem(config.localStorageKey, keycloak.token);
  setupAxios();

  keycloak.loadUserProfile();
};

const onAuthLogout = () => {
  clearToken();
  localStorage.clear();
};

setTimeout(() => {
  if (keycloak.authenticated) {
    keycloak
      .updateToken(70)
      .then(refreshed => {
        if (refreshed) {
          console.debug(`Token refreshed${refreshed}`);
        } else {
          console.warn(
            `Token not refreshed, valid for ${Math.round(
              keycloak.tokenParsed.exp +
                keycloak.timeSkew -
                new Date().getTime() / 1000
            )} seconds`
          );
        }
      })
      .catch(() => {
        console.error('Failed to refresh token');
      });
  } else {
    console.error('not auth');
  }
}, 60000);

export default keycloak;
export { onAuthLogout, onAuthSuccess };
